import {Layout, Divider, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Ocho = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '0vh'}}>Integrating everything through a Point of Care approach</Paragraph>
        <Text className='BaseText2'>Healthcare should be affordable and available for everybody. For that reason, we decided to design our biosensor as a lateral flow assay, which is a Point of Care device (PoC). PoC testing can be defined as medical testing closer to the care site and its aim is to deliver less costly results in the place where they are needed [29]. It is also a strategy to decentralize testing and it offers rapid results for earlier therapeutic intervention. Taking this into account, we followed the <q>ASSURED</q> criteria for POC devices which are: affordable, sensitive, specific, userfriendly, and robust [30].</Text>
        <Text className='BaseText2' style={{marginLeft: '5%', marginRight: '5%', marginTop: '3%'}}><b> In conclusion, our aptamer-based lateral flow assay is a practical and affordable device that gives a semiquantitative measurement of inflammaging biomarkers that could be used to predict and prevent age-related diseases.</b></Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Ocho;
